/**
 * @file modes.js
 * Exports constants pertaining to modes. These should be url-friendly.
 */

export const MODE_SCENE_CREATE = 'mode-scene-create';
export const MODE_SCENE_EDIT = 'mode-scene-edit';
export const MODE_SCENE_ROTATE = 'mode-scene-rotate';
export const MODE_COMPONENT_SELECTING = 'mode-component-selecting';
export const MODE_COMPONENT_PLACING = 'mode-component-placing';



// WEBPACK FOOTER //
// ./src/constants/modes.js